import { render } from "./OapBadge.vue?vue&type=template&id=a7b94682"
import script from "./OapBadge.vue?vue&type=script&lang=js"
export * from "./OapBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__